/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable no-promise-executor-return */
export const formatMoney = (
  { amount = 0, currencyCode = 'USD' },
  cents = false,
) => {
  let amt = amount;
  let hasFraction = false;
  if (Number.isNaN(+amt)) {
    // eslint-disable-next-line no-console
    return console.error('utils/format-money.js: No amount value passed.');
  }

  if (cents) {
    amt /= 100;
  } else {
    hasFraction = amt % 1 !== 0;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: (cents || hasFraction) ? 2 : 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(amt);
};

export const getCookie = (cname) => {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return null;
};

export const formatMetaobjectList = (metaobjects) => {
  const formattedMetaobjects = [];
  if (metaobjects) {
    metaobjects.forEach((metaobject) => {
      const formattedMetaobject = [];
      if (metaobject.node?.fields) {
        metaobject.node?.fields.forEach((field) => {
          if (field.type === 'file_reference') {
            formattedMetaobject[field.key] = field.reference?.image?.url;
          } else {
            formattedMetaobject[field.key] = field.value;
          }
        });
        formattedMetaobject.handle = metaobject.node?.handle;
        formattedMetaobjects.push(formattedMetaobject);
      }
    });
  }
  return formattedMetaobjects;
};

/**
 * Used to throttle events like scroll
 * @param {Function} callbackFn
 * @param {Int} limit
 * @returns
 */
export const throttle = (callbackFn, limit) => {
  let wait = false;
  return () => {
    if (!wait) {
      callbackFn.call();
      wait = true;
      setTimeout(() => {
        wait = false;
      }, limit);
    }
  };
};

export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const truncateString = (str, num) => {
  if (str.length > num) {
    return `${str.slice(0, num)}...`;
  }
  return str;
};

export const waitForElm = (selector) =>
  new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

export const hasRichTextContent = (richText) => {
  const parser = new DOMParser();
  const html = parser.parseFromString(
    richText.replaceAll(' ', ''),
    'text/html',
  );
  return html.body.textContent !== '';
};

export const localizeUrl = (url) => {
  // no need to change url if default locale
  if (window.Shopify.routes.root === '/' || !url) return url;

  if (
    (url.indexOf('nestnewyork.com') > -1 ||
      url.indexOf('www-nestny-stag-com.myshopify.com') > -1) &&
    url.indexOf(window.Shopify.routes.root) === -1
  ) {
    return url.replace('.com/', `.com${window.Shopify.routes.root}`);
  }
  return url;
};

export const liqTrack = (data, qty) => {
  window.liQ = window.liQ || [];
  const items = [];
  // eslint-disable-next-line array-callback-return
  data.map((product) => {
    items.push({
      id: String(product.id).replace('gid://shopify/Product/', ''),
      price: parseFloat(
        (product?.variants?.edges &&
          product?.variants?.edges[0]?.node?.price?.amount) ||
          (product?.variants[0].price || 0) / 100,
      ),
      quantity: parseInt(qty, 10),
      currency: window.TMW?.localization?.currencyCode || 'USD',
    });
  });
  window.liQ.push({
    event: 'addToCart',
    email: window.TMW.customer.email ? window.TMW.customer.email : '',
    items,
  });
};

export const liqTrackForm = (e, form) => {
  const email = form.querySelector('input[type="email"]').value;
  if (isValidEmail(email)) {
    window.liQ = window.liQ || [];
    window.liQ.push({
      event: 'conversion',
      name: 'email_signup',
      email,
    });
  } else {
    e.preventDefault();
    return false;
  }
};

export const debounce = (func, wait) => {
  let timeout;

  function debounced(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.cancel = () => {
    clearTimeout(timeout);
  };

  return debounced;
};

/**
 * The parseLinks function processes text and replaces custom links in the format
 * [(text:Link Text, url: https://example.com)] with HTML links.
 *
 * @param {string} text - The original text that may contain custom links.
 * @returns {string} - The text with replaced HTML links.
 */
export const parseLinks = (text) => {
  const linkRegex = /\[\(text:(.+?),\s*url:\s*(.+?)\)\]/g;

  return text.replace(
    linkRegex,
    (match, linkText, url) =>
      `<a href="${url.trim()}"
          class="animate-underline underline relative hover:!no-underline"
          target="_blank"
          rel="noopener noreferrer">
        ${linkText.trim()}
      </a>`,
  );
};

/**
 * Returns a price object with the given amount and the current currency code.
 * The currency code is taken from window.TMW.localization.currencyCode if available, otherwise defaults to 'USD'.
 *
 * @param {number} amount - The price amount (in cents or units, depending on usage).
 * @returns {{ amount: number, currencyCode: string }} The formatted price object.
 */
export const getFormattedPriceObject = (amount) => ({
  amount,
  currencyCode: window.TMW?.localization?.currencyCode || 'USD',
});
